import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { businessSlice } from '../../../../../../features/business/businessSlice';
import { useConfig } from '../../../../../../app/configcontext';
import ProtectedPaymentRoute from '../../../../../auth/Auth';

export default function Foundkit() {
  ProtectedPaymentRoute();

  const navigate = useNavigate();
  const config = useConfig();
  const expeditedProcess = config?.expeditedProcess || [];

  const dispatch = useDispatch();
  const actions = businessSlice.actions;

  const [selectedOption, setSelectedOption] = useState('yes');

  useEffect(() => {
    localStorage.setItem("accessForInvoice", "1");
    const storedExpeditedProcess = localStorage.getItem('selectedExpeditedProcess');
    if (storedExpeditedProcess) {
      setSelectedOption(storedExpeditedProcess);
    }
  }, []);

  const handleNextButtonClick = (event) => {
    event.preventDefault();
    if (selectedOption === "yes") {
      dispatch(actions.add_expeditedProcessId(1));
    } else {
      dispatch(actions.remove_expeditedProcessId());
    }
    navigate("/invoice");
  };

  const handleNextPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleNextButtonClick(event);
    }
  };

  const backbtn = () => {
    navigate("/bank_details");
  };

  const handleExpeditedProcessChange = (val) => {
    setSelectedOption(val);
    localStorage.setItem('selectedExpeditedProcess', val);
  };

  const expeditedPrice = expeditedProcess[0]?.price || 49;

  return (
    <div className="min-h-[75vh] bg-white py-12 lg:py-20 font-sans">
      <div className="container mx-auto px-4 lg:px-8 max-w-3xl">
        
        {/* Header */}
        <div className="mb-10 text-center max-w-2xl mx-auto">
          <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-2 block">
            Filing Speed & Priority
          </span>
          <h1 className="text-3xl sm:text-4xl font-normal text-[#202124] tracking-tight mb-3">
            Choose your state filing processing speed
          </h1>
          <p className="text-[15px] text-[#5f6368] leading-relaxed">
            Standard government processing can take several weeks. Upgrade to expedited Oktobiz priority filing to fast-track your formation.
          </p>
        </div>

        {/* Options */}
        <form onKeyDown={handleNextPress} className="space-y-4 mb-10 max-w-2xl mx-auto">
          {/* Option: Expedited */}
          <div
            onClick={() => handleExpeditedProcessChange('yes')}
            className={`p-6 rounded-[12px] border-2 cursor-pointer transition-all ${
              selectedOption === 'yes'
                ? "border-[#1a73e8] bg-[#f8fafd] shadow-sm"
                : "border-[#dadce0] bg-white hover:border-[#bdc1c6]"
            }`}
          >
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-3.5">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center mt-0.5 transition-all shrink-0 ${
                  selectedOption === 'yes' ? "border-[#1a73e8] bg-transparent" : "border-[#747775] bg-white"
                }`}>
                  {selectedOption === 'yes' && <div className="w-2.5 h-2.5 rounded-full bg-[#1a73e8]"></div>}
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-[16px] font-medium text-[#202124]">Expedited Priority Filing</span>
                    <span className="px-2 py-0.5 rounded text-[11px] font-semibold bg-[#e6f4ea] text-[#1e8e3e]">FASTEST</span>
                  </div>
                  <p className="text-[13.5px] text-[#5f6368] mt-1 leading-relaxed">
                    Priority preparation and fast-track submission to the Secretary of State. Estimated turnaround: 1-3 business days.
                  </p>
                </div>
              </div>
              <span className="text-lg font-semibold text-[#202124] ml-4 flex-shrink-0">${expeditedPrice}</span>
            </div>
          </div>

          {/* Option: Standard */}
          <div
            onClick={() => handleExpeditedProcessChange('no')}
            className={`p-6 rounded-[12px] border-2 cursor-pointer transition-all ${
              selectedOption === 'no'
                ? "border-[#1a73e8] bg-[#f8fafd] shadow-sm"
                : "border-[#dadce0] bg-white hover:border-[#bdc1c6]"
            }`}
          >
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-3.5">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center mt-0.5 transition-all shrink-0 ${
                  selectedOption === 'no' ? "border-[#1a73e8] bg-transparent" : "border-[#747775] bg-white"
                }`}>
                  {selectedOption === 'no' && <div className="w-2.5 h-2.5 rounded-full bg-[#1a73e8]"></div>}
                </div>
                <div>
                  <span className="text-[16px] font-medium text-[#202124]">Standard Processing</span>
                  <p className="text-[13.5px] text-[#5f6368] mt-1 leading-relaxed">
                    Standard state queue processing. Estimated turnaround: 5-14 business days depending on state volume.
                  </p>
                </div>
              </div>
              <span className="text-sm font-medium text-[#5f6368] ml-4 flex-shrink-0">Included ($0)</span>
            </div>
          </div>
        </form>

        {/* Footer Actions */}
        <div className="flex items-center justify-between pt-6 border-t border-[#f1f3f4] max-w-2xl mx-auto">
          <button
            type="button"
            onClick={backbtn}
            className="px-6 py-2.5 rounded-[4px] border border-[#dadce0] text-[#1a73e8] font-medium hover:bg-[#f8f9fa] transition-colors flex items-center gap-2 cursor-pointer text-[14px]"
          >
            <i className="fa-solid fa-arrow-left text-xs"></i> Back
          </button>
          <button
            type="button"
            onClick={handleNextButtonClick}
            className="px-8 py-2.5 rounded-[4px] bg-[#1a73e8] hover:bg-[#1557b0] !text-white font-medium shadow-sm transition-all flex items-center gap-2 cursor-pointer text-[14px]"
          >
            Continue to Order Summary <i className="fa-solid fa-arrow-right text-xs"></i>
          </button>
        </div>

      </div>
    </div>
  );
}
